export const accessControlBranding = {
  appName: 'Access Control Admin',
  heroTitle: 'Access Control Admin',
  heroSubtitle: 'Secure, centralized access governance for tenants and teams.',
  heroFeatures: [
    'Tenant and role governance',
    'MFA, SSO, and passkeys',
    'Audit-ready access controls',
  ],
  homeSummary:
    'Manage tenants, users, roles, permissions, feature flags, consents and sessions.',
  ctaTitle: 'Ready to administer access?',
  ctaSubtitle: 'Sign in to reach the admin dashboard and start managing your system.',
  heroImageUrl:
    'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070&auto=format&fit=crop',
  logoLightSrc: '/logo-light.png',
  logoDarkSrc: '/logo-dark.png',
  adminTagLabel: 'Admin',
} as const;
